<template>
  <div class="sideBar" id="domSideBar">
    <el-scrollbar>
      <el-menu
        :default-active="activeMenu"
        class="el-menu-vertical-demo"
        background-color="#3a3f51"
        text-color="#b5b6bd"
        active-text-color="rgb(79, 148, 212)"
        mode="vertical"
        :collapse-transition="false"
        :collapse="opened"
      >
        <sidebar-item
          v-for="item in mineRoutes"
          :key="item.path"
          :item="item"
          :basePath="item.path"
        ></sidebar-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import SidebarItem from './SiderBarltem'
import { mapGetters } from 'vuex'
export default {
  components: { SidebarItem },
  computed: {
    // ...mapGetters(['routes', 'opened']),
    ...mapGetters(['opened']),
    activeMenu() {
      return this.$route.path
    },
  },
  data(){
    return {
      routes: this.$store.getters.routes,
      mineRoutes: [], // 有权限的菜单
    }
  },
  mounted() {
    console.log(this.$store.getters.routes)
    // 通过权限，来判断要不要展示左侧驾驶舱看板
    // const canSeeStatic = localStorage.getItem('isShowStatic');
    // if(!canSeeStatic){
    //   this.$router.replace('/login')
    // }
    // if(canSeeStatic === 'true'){
    //   this.mineRoutes = this.routes;
    // } else {
    //   let restArr = []
    //   restArr = this.forSearchArr(this.routes)
    //   this.mineRoutes = restArr;
    // }
    // console.log(this.mineRoutes)

    this.mineRoutes = this.$store.getters.routes


  },
  methods:{
    forSearchArr(route) {
      let arrNew = []
      for (let item of route) {
        let itemNew = {};
        if(!item.isAuth){
          itemNew = { ...item } //解决浅拷贝共享同一内存地址
          if (itemNew.children) {
            itemNew.children = this.forSearchArr(itemNew.children)
          }
        }
        arrNew.push(itemNew)
      }

      return arrNew
    }
  }
}
</script>
